import { Box, Typography, useTheme } from "@mui/material";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { useEffect, useState } from "react";
import { resolveMediaUrl } from "../../helper/resolveMediaUrl";
import CoursePlaceholder from "../../images/login/background2.png";

/** Course/path grid card — rounded card with image, hover lift, fallback placeholder. */
export default function GridMediaCard({
    image,
    title,
    description,
    actions,
    onClick,
    footer,
    header,
    className = "",
    imageHeight = 168,
}) {
    const theme = useTheme();
    const [failed, setFailed] = useState(false);
    const src = resolveMediaUrl(image);
    const showPlaceholder = !src || failed;

    useEffect(() => {
        setFailed(false);
    }, [src]);

    return (
        <Box
            onClick={onClick}
            sx={{
                backgroundColor: theme.palette.background.paper,
                cursor: onClick ? "pointer" : "default",
                height: footer || actions ? "auto" : "100%",
                display: "flex",
                flexDirection: "column",
                border: "1px solid",
                borderColor: theme.palette.mode === "dark" ? "divider" : "#e2e8f0",
            }}
            className={`rounded-2xl bg-white shadow-lg overflow-hidden w-full home-card-hover ${className}`}
        >
            {!header && (
                <Box sx={{ position: "relative", height: imageHeight, flexShrink: 0, overflow: "hidden" }}>
                    {showPlaceholder ? (
                        <Box
                            sx={{
                                height: "100%",
                                background: "linear-gradient(135deg, #0D358C 0%, #2563EA 50%, #457b9d 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                position: "relative",
                            }}
                        >
                            <Box
                                component="img"
                                src={CoursePlaceholder}
                                alt=""
                                sx={{
                                    position: "absolute",
                                    inset: 0,
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    opacity: 0.35,
                                }}
                            />
                            <MenuBookOutlinedIcon sx={{ fontSize: 48, color: "rgba(255,255,255,0.9)", zIndex: 1 }} />
                        </Box>
                    ) : (
                        <Box
                            component="img"
                            src={src}
                            alt={title || ""}
                            onError={() => setFailed(true)}
                            sx={{ height: "100%", width: "100%", objectFit: "cover", display: "block" }}
                        />
                    )}
                    <Box
                        sx={{
                            position: "absolute",
                            insetInline: 0,
                            bottom: 0,
                            height: "45%",
                            background: "linear-gradient(to top, rgba(4,14,38,0.55), transparent)",
                            pointerEvents: "none",
                        }}
                    />
                </Box>
            )}
            {header ? <Box className="px-3 pt-3 flex justify-center">{header}</Box> : null}
            <Box className="px-3 pt-3 pb-3" sx={{ flex: 1 }}>
                <Typography
                    gutterBottom
                    variant="h6"
                    component="div"
                    className="!text-base !font-bold"
                    sx={{ color: "#0D358C", lineHeight: 1.35 }}
                    noWrap
                >
                    {title}
                </Typography>
                {description ? (
                    <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
                        {description}
                    </Typography>
                ) : null}
                {footer ? <Box className="mt-2">{footer}</Box> : null}
            </Box>
            {actions ? <Box className="px-2 pb-2 flex flex-wrap gap-1">{actions}</Box> : null}
        </Box>
    );
}
